import { render } from "./WishlistComponent.vue?vue&type=template&id=679fc6f0"
import script from "./WishlistComponent.vue?vue&type=script&lang=js"
export * from "./WishlistComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__